<template>
    <modal name="become-member-modal" @opened="opened" @closed="closed">
        <div class="py-24 py-md-40 px-md-24">
            <become-member-form :title="translations.become_member_form_title" :description="translations.become_member_form_description" :translations="translations"></become-member-form>
            <span class="close" @click="$modal.hide('become-member-modal')"></span>
        </div>
    </modal>
</template>

<script>
import disableHtmlScroll from '@mixins/disableHtmlScroll'

export default {
    mixins: [disableHtmlScroll],

    props: {
        translations: {
            type: Object,
            required: true
        }
    },
    methods: {
        opened: async function () {
            await this.$recaptchaLoaded()
            const recaptcha = this.$recaptchaInstance
            recaptcha.showBadge()

            disableHtmlScroll.methods.opened.bind(this)()
        },
        closed: async function () {
            await this.$recaptchaLoaded()
            const recaptcha = this.$recaptchaInstance
            recaptcha.hideBadge()

            disableHtmlScroll.methods.closed.bind(this)()
        },
    },
}
</script>